import CertTestPanel from "./CertTestPanel";

export default class CertTestAdminApp {
    static certTestPanel: CertTestPanel;

    public static alert(title: string, message: string) {

        let alertBox = <HTMLDivElement>document.getElementById("alert-box");

        alertBox.innerHTML = '\
            <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>\
            <strong></strong> <span></span>\
        ';

        let closeAnchor = alertBox.firstElementChild;
        let titleElement = <HTMLElement>closeAnchor.nextElementSibling;
        let messageElement = <HTMLElement>titleElement.nextElementSibling;

        closeAnchor.addEventListener("click", (ev) => {
            CertTestAdminApp.clearAlert();
        });

        titleElement.innerText = title;
        messageElement.innerText = message;

        alertBox.classList.remove("hidden");
    }


    public static clearAlert() {
        let alertBox = <HTMLDivElement>document.getElementById("alert-box");

        alertBox.innerHTML = "";
        alertBox.className = alertBox.className + " hidden";
    }

    constructor() {
        CertTestAdminApp.certTestPanel = new CertTestPanel();
    }

}
